import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import '../../Landing/Dashboard/style.css';

const Dashboard = ({ divRef, pricingRef, joinHandler }) => {
  const [openNav, setOpenNav] = useState(false);
  const Background = require('../../../assets/expert.png');
  const Background2 = require('../../../assets/space.png');
  const ellipse = require('../../../assets/Ellipse.png');
  const videoRef = useRef(null);
  const { ref: videoDivRef, inView: isDivVisible } = useInView();

  useEffect(() => {
    document.body.style.overflowY = openNav ? 'hidden' : 'scroll';
    if (isDivVisible) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [openNav, videoRef, isDivVisible]);

  return (
    <div className='wrapper' ref={divRef}>
      <div className='expedition'></div>
      <div
        className='sideNav'
        style={{ transform: openNav ? 'translateX(0)' : 'translate(100%)' }}
      >
        {' '}
        <div className='sideNav-wrapper'>
          <span
            className='sideNav-link'
            onClick={() => {
              setOpenNav((prev) => !prev);
              window.scrollTo({
                behavior: 'smooth',
                top: divRef.current.offsetTop,
              });
            }}
          >
            Home
          </span>
          <span className='sideNav-link'>About Us</span>
          <span
            className='sideNav-link'
            onClick={() => {
              setOpenNav((prev) => !prev);
              window.scrollTo({
                behavior: 'smooth',
                top: pricingRef.current.offsetTop,
              });
            }}
          >
            Pricing
          </span>
          <span className='sideNav-link'>FAQs</span>
        </div>
      </div>
      <div className='navBar'>
        <div className='logo'>
          <div className='logo-box'></div>
          <div className='logo-text'>Kalam Labs</div>
        </div>
        <span className='btn' onClick={joinHandler}>
          Join Now
        </span>
        <div
          className='nav-ham'
          onClick={() => {
            setOpenNav((prevVal) => !prevVal);
          }}
          style={{
            transform: openNav ? 'rotate(90deg)' : 'rotate(0deg)',
            transformOrigin: '50% 50%',
          }}
        >
          <span style={{ background: openNav ? '#B43C60' : '#433267' }}></span>
          <span style={{ background: openNav ? '#B43C60' : '#433267' }}></span>
          <span style={{ background: openNav ? '#B43C60' : '#433267' }}></span>
        </div>
      </div>
      <div className='navBar-dummy'></div>
      <div className='main-div'>
        <div className='details-div'>
          <span className='details-text'>
            Live Space Sessions
            <br />
            which your child will love
          </span>
          <span className='details-subtext'>
            World’s Leading Space Curriculum for Kids
          </span>
          <span className='details-btn' onClick={joinHandler}>
            Join Now
          </span>
        </div>
        <div className='landing-logo'>
          <div className='landing-bubble'></div>
          <div className='landing-bubble-right'></div>
        </div>
      </div>
      <div className='video-div'>
        <span className='video-heading'>
          Fulfill Your Child’s Dream to be an{' '}
          <span className='video-heading-color'>Astronaut</span>
        </span>
        <div className='video-content'>
          <div
            className='video-content-div'
            style={{
              backgroundImage: `url(${ellipse})`,
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className='phone-frame'>
              <div className='volume-rocker'></div>
              <div className='volume-rocker'></div>
              <div className='power-btn'></div>
              <div className='screen'>
                <video
                  ref={videoRef}
                  width='100%'
                  height='100%'
                  src={require('../../../assets/video.mp4')}
                  autoPlay={true}
                  className='video-element'
                  controls
                />
              </div>
            </div>
          </div>
          <div className='video-content-div'>
            <span className='mobile-heading'>
              Fulfill Your Child’s
              <br />
              Dream to be an
              <br />
              <span className='mobile-heading-color'>Astronaut</span>
            </span>

            <div className='video-content-card'>
              <span className='video-content-card-text'>
                Expert Led Space <br /> Sessions
              </span>
              <div
                className='video-content-card-image'
                style={{ backgroundImage: `url(${Background})` }}
              ></div>
            </div>
            <div className='video-content-card'>
              <div
                className='video-content-card-image'
                style={{ backgroundImage: `url(${Background2})` }}
              ></div>

              <span ref={videoDivRef} className='video-content-card-text'>
                Fun Science <br />
                Activities
              </span>
            </div>
            <span className='mobile-btn' onClick={joinHandler}>
              Join now
            </span>
          </div>
        </div>
      </div>
      <div className='footer-div'>
        <span className='footer-text'>
          Want your child to be a part of this?
        </span>
        <span className='footer-btn' onClick={joinHandler}>
          Join now
        </span>
      </div>
    </div>
  );
};

export default Dashboard;
